// Source
import * as ModelCustomRoute from "../../model/custom/Route";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const setCustomOnClick = (result: ModelCustomRoute.Idata, parameterList: Record<string, unknown> | undefined): void => {};
